export const H24_IMG_WIDTH = ['86.5px', '93px', '118px'];
export const H24_IMG_HEIGHT = ['30.8px', '33px', '42px'];
